module.exports = __webpack_public_path__ + "static/img/dark_image-min.f4be9fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dark_image-min.jpg
// module id = 3H8t
// module chunks = 1